
getBundleGiftJson();

function getBundleGiftJson() {
	var bundleGiftData = theme.settings.bundleGiftData;
	let bundleGiftJson = {};
	if (bundleGiftData) {
		bundleGiftData.forEach(item => {
			const giftId = item.gift.split('/').pop();
			const productIds = item.products.map(product => product.split('/').pop());
			if (productIds.length > 0) {
				bundleGiftJson[giftId] = productIds;
			}
		});
	}

	if (Object.keys(bundleGiftJson).length > 0) {
		window.bundleGiftJson = bundleGiftJson;
	}
}
